"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JurisdictionRules = void 0;
const browser_1 = require("encamp-prisma/generated/browser");
const isNonEmpty_1 = require("encamp-shared/dist/utils/isNonEmpty");
/**
 * Note that these classes are meant to be singletons instantiated at module load.
 * They should never carry any instance state, only static constants and pure functions.
 *
 * Jurisdictions do not inherit rules from one another: each writes out its
 * whole answer, calling the `Federal` functions wherever its law matches
 * federal law.
 */
class JurisdictionRules {
    thresholdsFor(situation) {
        if (situation.container !== undefined) {
            return this.containerThresholds({
                facility: situation.facility,
                area: situation.area ?? {},
                container: situation.container,
            });
        }
        if (situation.area !== undefined) {
            return this.areaThresholds({ facility: situation.facility, area: situation.area });
        }
        return this.facilityThresholds(situation.facility);
    }
    /**
     * Shared by every jurisdiction; states vary only the category, program, and
     * `adoptsEpisodicEvents`. Any axis that rules the container out settles it;
     * otherwise `missing` names only the axes the threshold reads.
     */
    thresholdIncludes(threshold, container) {
        if (threshold.kind !== "WASTE_AMOUNT") {
            throw new Error(`${threshold.id} sums no waste.`);
        }
        const { includedCategories, includedPrograms } = threshold;
        if (includedCategories === undefined || includedPrograms === undefined) {
            throw new Error(`${threshold.id} does not say which containers it sums.`);
        }
        const missing = [];
        if (Object.values(browser_1.WasteKind).some((p) => !includedPrograms.includes(p))) {
            const program = this.governingProgram(container);
            if (program.value === undefined) {
                missing.push(...program.missing);
            }
            else if (!includedPrograms.includes(program.value)) {
                return { value: false };
            }
        }
        const category = this.accumulationCategory(container);
        if (category.value === undefined) {
            missing.push(...category.missing);
        }
        else if (!includedCategories.some((c) => c === category.value)) {
            return { value: false };
        }
        const episodicExcluded = this.episodicExclusion(container);
        if (episodicExcluded.value === undefined) {
            missing.push(...episodicExcluded.missing);
        }
        else if (episodicExcluded.value) {
            return { value: false };
        }
        return (0, isNonEmpty_1.isNonEmpty)(missing) ? { missing } : { value: true };
    }
    episodicExclusion(container) {
        if (!this.adoptsEpisodicEvents) {
            return { value: false };
        }
        if (container.attachedToActiveEpisodicEvent === undefined) {
            return { missing: ["container.attachedToActiveEpisodicEvent"] };
        }
        return { value: container.attachedToActiveEpisodicEvent };
    }
}
exports.JurisdictionRules = JurisdictionRules;
//# sourceMappingURL=_base.js.map